import { Outlet, Link, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next"; // Импортируем хук перевода
import logo from "../assets/logo.svg";
import Footer from "./footer";
import armflag from '../assets/flags/am.png';
import ruflag from '../assets/flags/ru.png';
import enflag from '../assets/flags/en.png'
const Layout = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [scrollPosition, setScrollPosition] = useState(0);
  const [active, setActive] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isHomeLoading, setIsHomeLoading] = useState(location.pathname === "/" && !sessionStorage.getItem('hasVisitedHome'));

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    const handleScroll = () => setScrollPosition(window.scrollY);

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (isHomeLoading) {
      const timer = setTimeout(() => {
        setIsHomeLoading(false);
        sessionStorage.setItem('hasVisitedHome', 'true');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isHomeLoading]);

  const isMobile = windowWidth <= 1024;

  const toggleMenu = () => {
    setActive(!active);
    if (active) setDropdownOpen(false);
  };

  const toggleDropdown = (e) => {
    if (isMobile) {
      e.preventDefault();
      setDropdownOpen(!dropdownOpen);
    }
  };

  // Функция смены языка
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <>
      {!(location.pathname === "/" && !sessionStorage.getItem('hasVisitedHome')) && (
        <>
          {/* --- ОТДЕЛЬНАЯ ПАНЕЛЬ ЯЗЫКОВ С ФЛАГАМИ --- */}
          <div className="fixed top-4 right-20 z-[10002] flex gap-3 bg-black/20 backdrop-blur-md p-2 rounded-full border border-white/10 px-4">
            <button onClick={() => changeLanguage('am')} className={`hover:scale-125 transition-transform ${i18n.language === 'am' ? 'opacity-100' : 'opacity-50'}`} title="Armenian">
              <span className="text-xl"><img src={armflag} alt="" /></span>
            </button>
            <button onClick={() => changeLanguage('ru')} className={`hover:scale-125 transition-transform ${i18n.language === 'ru' ? 'opacity-100' : 'opacity-50'}`} title="Russian">
              <span className="text-xl"><img src={ruflag} alt="" /></span>
            </button>
            <button onClick={() => changeLanguage('en')} className={`hover:scale-125 transition-transform ${i18n.language === 'en' ? 'opacity-100' : 'opacity-50'}`} title="English">
              <span className="text-xl"><img src={enflag} alt="" /></span>
            </button>
          </div>

          {/* Кнопка Бургер (Mobile) */}
          {isMobile && (
            <button
              onClick={toggleMenu}
              className={`fixed right-5 top-5 z-[10001] flex h-12 w-12 items-center justify-center rounded-full border ${scrollPosition > 150 ? "border-yellow-500 shadow-2xl" : "border-white/50"}  text-white`}
            >
              <div className="relative w-6 h-4">
                <span className={`absolute left-0 top-0 h-[2px] w-full ${scrollPosition > 150 ? "bg-yellow-500 shadow-2xl" : "bg-white/50"} transition-all duration-300 ${active ? "top-1/2 rotate-45" : ""}`} />
                <span className={`absolute left-0 top-1/2 h-[2px] w-full ${scrollPosition > 150 ? "bg-yellow-500 shadow-2xl" : "bg-white/50"} transition-all duration-300 -translate-y-1/2 ${active ? "opacity-0" : ""}`} />
                <span className={`absolute left-0 bottom-0 h-[2px] w-full ${scrollPosition > 150 ? "bg-yellow-500 shadow-2xl" : "bg-white/50"} transition-all duration-300 ${active ? "top-1/2 -rotate-45" : ""}`} />
              </div>
            </button>
          )}

          {/* Основная навигация */}
          <nav
            className={`fixed z-[99999] w-max transition-all duration-500 will-change-transform backdrop-blur-md
    ${scrollPosition > 150 ? "bg-[#0058a3]/30 shadow-2xl" : "bg-transparent"}
    ${
      !isMobile
        ? "left-1/2 top-[10%] h-[100px] w-auto -translate-x-1/2 -translate-y-1/2 flex items-center justify-center rounded-[60px] border-[3px] border-yellow-500 px-8 py-5 hover:border-yellow-400 animate-[showDesktop_1s_ease-out_0.1s_both]"
        : `top-0 right-0 h-screen w-[300px] bg-[#0058a3]/30 border-l-[3px] border-yellow-400 flex flex-col p-10 pt-28 shadow-[-10px_0_30px_rgba(0,0,0,0.5)] transform transition-transform ${active ? "translate-x-0" : "translate-x-full"}`
    }
  `}
          >
            <ul className={`flex w-full ${isMobile ? "flex-col gap-8" : "flex-row items-center justify-center gap-4"}`}>
              {!isMobile && (
                <li className="mx-6 shrink-0 -translate-y-1">
                  <Link to="/">
                    <img className="h-12 w-auto object-contain" src={logo} alt="logo" />
                  </Link>
                </li>
              )}
              
              <li className={`group relative uppercase text-white cursor-pointer hover:text-yellow-400 transition-all ${!isMobile ? "w-[100px] text-center" : "text-lg font-semibold"}`}>
                <Link to="/" onClick={() => isMobile && toggleMenu()}>
                  {t('home')}
                </Link>
              </li>

              <li className={`group relative uppercase text-white cursor-pointer ${!isMobile ? "text-center" : "w-full"}`}>
                <div className="flex items-center justify-between hover:text-yellow-400 transition-all" onClick={toggleDropdown}>
                  <span className={isMobile ? "text-lg font-semibold" : ""}>
                    {t('about')}
                  </span>
                  {isMobile && (
                    <svg className={`w-5 h-5 transition-transform duration-300 ${dropdownOpen ? "rotate-180" : ""}`} viewBox="0 0 20 20" fill="currentColor">
                      <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                    </svg>
                  )}
                </div>

                <div className={`grid transition-all duration-500 ease-in-out ${!isMobile ? "absolute left-[-40%] top-[110%] w-[150px] bg-[#0058a3] rounded-b-xl border-yellow-400 opacity-0 invisible group-hover:opacity-100 group-hover:visible border-b-[3px] border-x-[1px] shadow-2xl" : `relative overflow-hidden ${dropdownOpen ? "grid-rows-[1fr] mt-4 opacity-100" : "grid-rows-[0fr] opacity-0"}`}`}>
                  <ul className={`min-h-0 transition-all duration-500 ${isMobile ? `border-l-2 border-yellow-500 ml-2 bg-[#0058a3] flex flex-col gap-4 ${dropdownOpen ? "p-3" : "py-0 px-3"}` : "p-1 flex flex-col gap-2"}`}>
                    {[
                      { label: t('team'), path: "/team" }, 
                      { label: t('jobs'), path: "/jobs" },
                      { label: t('certificates'), path: "/certificates" }, 
                      { label: t('videos'), path: "/videos" }
                    ].map((item) => (
                      <li key={item.path}>
                        <Link className="text-xs text-white/80 hover:text-yellow-400 transition-colors block py-1" to={item.path} onClick={() => isMobile && toggleMenu()}>
                          {item.label}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
               <li className={`group relative uppercase text-white cursor-pointer hover:text-yellow-400 transition-all ${!isMobile ? "text-center" : "text-lg font-semibold"}`}>
                <Link to="works" onClick={() => isMobile && toggleMenu()}>
                  {t('portfolio')}
                </Link>
              </li>
               <li className={`group relative uppercase text-white cursor-pointer hover:text-yellow-400 transition-all ${!isMobile ? " text-center" : "text-lg font-semibold"}`}>
                <Link to="branches" onClick={() => isMobile && toggleMenu()}>
                  {t('branches')}
                </Link>
              </li>

              <li className={`group relative uppercase text-white cursor-pointer hover:text-yellow-400 transition-all ${!isMobile ? " text-center" : "text-lg font-semibold"}`}>
                <Link to="services" onClick={() => isMobile && toggleMenu()}>{t('services')}</Link>
              </li>
            
              <li className={`group relative uppercase text-white cursor-pointer hover:text-yellow-400 transition-all ${!isMobile ? "text-center" : "text-lg font-semibold"}`}>
            <Link to="contact" onClick={() => isMobile && toggleMenu()}>{t('contact')}</Link>
          </li>
        </ul>
      </nav>

      {isMobile && active && (
        <div className="fixed inset-0 bg-black/70 z-[9998] transition-opacity duration-500" onClick={toggleMenu} />
      )}
    </>
  )}

  <main>
    <Outlet />
    
    {/* Scroll to Top Button */}
    {!(location.pathname === "/" && !sessionStorage.getItem('hasVisitedHome')) && scrollPosition > 300 && (
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-6 right-6 z-[10000] bg-yellow-400 hover:bg-yellow-300 text-black p-3 rounded-full shadow-lg transition-all duration-300 animate-bounce"
        aria-label="Scroll to top"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 10l7-7m0 0l7 7m-7-7v18"
          />
        </svg>
      </button>
    )}
    
    <Footer />
  </main>
</>
);
};

export default Layout;